import { render, staticRenderFns } from "./WelcomeContentComponent.vue?vue&type=template&id=6db2b1d9&scoped=true&"
import script from "./WelcomeContentComponent.vue?vue&type=script&lang=js&"
export * from "./WelcomeContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeContentComponent.vue?vue&type=style&index=0&id=6db2b1d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2b1d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db2b1d9')) {
      api.createRecord('6db2b1d9', component.options)
    } else {
      api.reload('6db2b1d9', component.options)
    }
    module.hot.accept("./WelcomeContentComponent.vue?vue&type=template&id=6db2b1d9&scoped=true&", function () {
      api.rerender('6db2b1d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/welcome/WelcomeContentComponent.vue"
export default component.exports